import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Optional, Output, signal } from '@angular/core';
import { SectionLayoutMetadata } from '../../model/dyn-form/form-metadata/layout/section-layout.model';
import { DynFormSectionBase } from '../../model/dyn-form/dyn-form-section.model';
import { forkJoin, Observable } from 'rxjs';
import { DynFormService } from '../../services/dyn-form/dyn-form.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { DynFormBase } from '../../model/dyn-form/dyn-form.model';
import { FormView } from '../../model/dyn-form/form-visualizer/formly-group.model';
import { CommonModule } from '@angular/common';
import { PageScrollContentComponent } from '../page-scroll-content/page-scroll-content.component';
import { FormInstanceController } from '../form-instance/form-instance-controller.model';
import { FormInstanceComponent } from '../form-instance/form-instance.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';

class FormController implements FormInstanceController {

    formView: FormView | null = null

    register(fv: FormView): void {
        this.formView = fv
    }

}

@Component({
    selector: 'app-form-preview',
    templateUrl: './form-preview.component.html',
    styleUrl: './form-preview.component.scss',
    standalone: true,
    imports: [
        CommonModule,
        PageScrollContentComponent, 
        FormInstanceComponent,
        MatButtonModule, MatIconModule, MatFormFieldModule, MatDialogModule
    ]
})
export class FormPreviewComponent implements OnInit {

    sectionMetadataMap: Map<number, SectionLayoutMetadata> = new Map()
    sectionFormControllerMap: Map<SectionLayoutMetadata, { controller: FormController, section: DynFormSectionBase }> = new Map()

    sections: SectionLayoutMetadata[] = []

    dynForm!: DynFormBase

    @Input() procedureFormId!: number

    @Output() getReady = new EventEmitter<any>()

    customData = signal<Map<string, any> | null>(null)

    constructor(protected dynFormService: DynFormService, protected snack: MatSnackBar, 
        @Optional() @Inject(MAT_DIALOG_DATA) public data: { procedureFormId: number } | null,
        private readonly changeDetectorRef: ChangeDetectorRef     
    ) {
        let customData = new Map<string, any>()
        customData.set('dummy', true)
        this.customData.set(customData)
    }

    ngOnInit(): void {

        if (this.data && this.data != null && this.data.procedureFormId) {
            this.procedureFormId = this.data.procedureFormId
        }

        this.dynFormService.findDynFormByProcedureFormId(this.procedureFormId).subscribe(r => {

            if (!r.ok && r.entity.sections.length == 0) {
                this.snack.open("No existeix el formulari: " + this.procedureFormId)
                return
            }

            this.dynForm = r.entity
            let jsonCalls: Observable<SectionLayoutMetadata>[] = []
            this.dynForm.sections.forEach(s => {
                jsonCalls.push(this.dynFormService.loadSection(s.id))
            })

            forkJoin<SectionLayoutMetadata[]>(jsonCalls).subscribe(r => {

                for (let index = 0; index < r.length; index++) {
                    const element = r[index];
                    this.sectionMetadataMap.set(this.dynForm.sections[index].id, element)
                    this.sectionFormControllerMap.set(element, { controller: new FormController(), section: this.dynForm.sections[index] })
                }
                this.sections = []
                this.dynForm.sections.sort(DynFormSectionBase.sortFn).forEach(s => {
                    let currentSection = this.sectionMetadataMap.get(s.id)
                    if (currentSection == null) {
                        console.log(`The section: ${s.name} not exists ...`)
                        return
                    }
                    this.sections.push(<SectionLayoutMetadata>this.sectionMetadataMap.get(s.id))
                })

                this.changeDetectorRef.detectChanges()
                
                if (!this.data || this.data == null || !this.data.procedureFormId ) {
                    this.getReady.emit()
                }
            })

        })
    }

    getController(key: SectionLayoutMetadata): FormController {
        return <FormController> this.sectionFormControllerMap.get(key)?.controller
    }

}
